export const Accordion = (openByDefault, maxHeight) => ({
  isOpen: false,
  contentHeight: 0,
  init() {
    if (openByDefault) requestAnimationFrame(() => this.toggleAccordion())
  },
  toggleAccordion(forceState = null, id = null) {
    if (forceState && id) {
      if (this.$root.id === id) this.isOpen = forceState
    } else {
      this.isOpen = !this.isOpen
    }
    if (this.isOpen) {
      this.contentHeight = maxHeight
        ? Math.min(this.$refs.content.scrollHeight, maxHeight)
        : this.$refs.content.scrollHeight
    } else {
      this.contentHeight = 0
    }

    if (this.$refs.minus) this.$refs.minus.ariaHidden = !this.isOpen
    if (this.$refs.plus) this.$refs.plus.ariaHidden = this.isOpen
  },
})
